export default "__VITE_PUBLIC_ASSET__8bc3d189__"